import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import GirlImage from '../assets/img/Volenter/Vole.webp';

const Volenter = () => {
  const [donationTypes, setDonationTypes] = useState({
    money: false,
    volunteer: false,
    other: false,
  });

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    address: '',
    phone: '',
    donationAmount: '',
    volunteerArea: '',
    message: '',
  });

  const handleCheckboxChange = (type) => {
    setDonationTypes({
      money: type === 'money',
      volunteer: type === 'volunteer',
      other: type === 'other',
    });
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = () => {
    const dataToSend = {
      full_name: formData.fullName,
      email: formData.email,
      address: formData.address,
      phone: formData.phone,
      message: formData.message,
      donation_type: Object.keys(donationTypes).find((key) => donationTypes[key]) || 'N/A',
      donation_amount: donationTypes.money ? formData.donationAmount : '',
      volunteer_area: donationTypes.volunteer ? formData.volunteerArea : '',
    };

    emailjs.send('service_wa76lmp', 'template_cf3z7g4', dataToSend, '7CgziywId045J0XQp')
      .then((res) => {
        alert("Thank you for your support! Your form has been submitted successfully. We will get back to you soon.");
        setFormData({
          fullName: '',
          email: '',
          address: '',
          phone: '',
          donationAmount: '',
          volunteerArea: '',
          message: '',
        });
        setDonationTypes({ money: false, volunteer: false, other: false });
      })
      .catch((err) => {
        console.error(err);
        alert("Something went wrong. Please try again later.");
      });
  };

  return (
    <section className="relative py-12 w-full min-h-[80vh] bg-[#F5F5F5]">
      <div className="mx-auto w-[90%] md:w-[70%] flex flex-col md:flex-row gap-8">
        {/* Form Section */}
        <div className="md:w-1/2 space-y-6">
          <p className="text-sm text-[#90444D] font-semibold uppercase font-playfair tracking-wider">Be our volunteer</p>
          <h2 className="text-2xl md:text-3xl font-bold font-playfair text-gray-900 tracking-wider">
            Join <span className="text-[#90444D]">Our Community</span> To Give
            <br />
            Health & Education For Children
          </h2>

          <div className="bg-gray-200 p-6 shadow-sm space-y-4">
            <p className="text-customGreen font-semibold text-lg">Support Where It Counts.</p>

            <div>
              <label className="block text-sm text-customGreen mb-1">Full Name</label>
              <input
                name="fullName"
                type="text"
                value={formData.fullName}
                onChange={handleInputChange}
                placeholder="Enter your full name"
                className="w-full px-4 py-2 border border-gray-300 text-sm rounded-md"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Email Address</label>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email"
                className="w-full px-4 py-2 border border-gray-300 text-sm rounded-md"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Address</label>
              <input
                name="address"
                type="text"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="Enter your address"
                className="w-full px-4 py-2 border border-gray-300 text-sm rounded-md"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Phone Number</label>
              <input
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Enter your phone number"
                className="w-full px-4 py-2 border border-gray-300 text-sm rounded-md"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Type of Donation</label>
              <div className="flex flex-wrap gap-4">
                {['volunteer', 'money', 'other'].map((type) => (
                  <label key={type} className="inline-flex items-center">
                    <input
                      type="checkbox"
                      checked={donationTypes[type]}
                      onChange={() => handleCheckboxChange(type)}
                      className="form-checkbox text-yellow-500"
                    />
                    <span className="ml-2 capitalize text-sm text-gray-700">
                      {type === 'money' ? 'Money Donation' : type}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            {donationTypes.money && (
              <div>
                <label className="block text-sm text-gray-600 mb-1">Donation Amount</label>
                <input
                  name="donationAmount"
                  type="number"
                  value={formData.donationAmount}
                  onChange={handleInputChange}
                  placeholder="Enter amount"
                  className="w-full px-4 py-2 border border-gray-300 text-sm rounded-md"
                />
              </div>
            )}

            {donationTypes.volunteer && (
              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Describe your volunteer area
                </label>
                <textarea
                  name="volunteerArea"
                  value={formData.volunteerArea}
                  onChange={handleInputChange}
                  rows={2}
                  placeholder="e.g. Kitchen support, tutoring, event organizing..."
                  className="w-full px-4 py-2 border border-gray-300 text-sm rounded-md"
                />
              </div>
            )}

            <div>
              <label className="block text-sm text-gray-600 mb-1">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Leave your message"
                rows={2}
                className="w-full px-4 py-2 border border-gray-300 text-sm rounded-md"
              />
            </div>

            <button
              onClick={sendEmail}
              className="mt-4 w-full bg-customGreen text-white font-semibold py-3 rounded-md hover:bg-customGreen-600 transition"
            >
              SEND
            </button>
          </div>
        </div>

        {/* Image Section */}
        <div className="md:w-1/2 relative hidden md:block">
          <div className="relative overflow-hidden h-full shadow-md">
            <img
              src={GirlImage}
              alt="Volunteer girl"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-l from-transparent via-white/60 to-white/90" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Volenter;
